// Metric registry for ad-testing questions. The renderer owns these definitions outright:
// the answer payload carries values only, never labels or unit tokens.

export const BASE_METRIC_OPTIONS = [
  { value: 'engagement', label: 'Engagement', metric: 'respondents' },
  { value: 'likes', label: 'Likes', metric: 'respondents' },
  { value: 'comments', label: 'Comments', metric: 'respondents' },
  { value: 'shares', label: 'Shares', metric: 'respondents' },
  { value: 'saves', label: 'Saves', metric: 'respondents' },
  { value: 'view', label: 'Views', metric: 'respondents' },
  { value: 'ad', label: 'Ad banner', metric: 'respondents' },
  { value: 'averageView', label: 'Average view duration', metric: 'seconds' }
]

// Facebook has no "save" interaction, so that metric is absent from the Facebook base list.
export const BASE_METRIC_OPTIONS_FACEBOOK = BASE_METRIC_OPTIONS.filter(option => 'saves' !== option.value)

export const VIDEO_METRIC_OPTIONS = [
  { value: 'totalPlays', label: 'Total plays', metric: 'count' },
  { value: 'playRate', label: 'Play rate', metric: 'respondents' },
  { value: 'completionRate', label: 'Video completion rate', metric: 'respondents' },
  { value: 'played25', label: 'Played 25%', metric: 'respondents' },
  { value: 'played50', label: 'Played 50%', metric: 'respondents' },
  { value: 'played75', label: 'Played 75%', metric: 'respondents' },
  { value: 'audioOnStaysOn', label: 'Sound was on, stays on', metric: 'count' },
  { value: 'audioOnTurnedOff', label: 'Sound was on, turned off', metric: 'count' },
  { value: 'audioOffStaysOff', label: 'Sound was off, stays off', metric: 'count' },
  { value: 'audioOffTurnedOn', label: 'Sound was off, turned on', metric: 'count' },
  { value: 'bounceRate', label: 'Bounce rate', metric: 'respondents' },
  { value: 'playedToPause', label: 'Video was auto-played, and the respondent hit the pause', metric: 'respondents' },
  { value: 'pausedToPlay', label: 'Video was paused, and the respondent hit play', metric: 'respondents' }
]

export const getMetricOptions = (mediaType, socialType, postType) => {
  let options = 'facebook' === socialType ? BASE_METRIC_OPTIONS_FACEBOOK : BASE_METRIC_OPTIONS

  // an embedded post carries no ad banner, so the banner-click metric is irrelevant
  if ('post' === postType) options = options.filter(option => 'ad' !== option.value)

  return 'video' === mediaType ? options.concat(VIDEO_METRIC_OPTIONS) : options
}
